import { render, staticRenderFns } from "./DynamicAlignment.vue?vue&type=template&id=42b5a1f8&scoped=true"
import script from "./DynamicAlignment.vue?vue&type=script&lang=js"
export * from "./DynamicAlignment.vue?vue&type=script&lang=js"
import style0 from "./DynamicAlignment.vue?vue&type=style&index=0&id=42b5a1f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b5a1f8",
  null
  
)

export default component.exports